






































import VueI18n from 'vue-i18n';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component
export default class WebApiSettingProfileDialog extends Vue {
  private dialog: boolean = false;

  @Prop()
  private iconColor!: string;
  @Prop()
  private icon!: string;
  @Prop()
  private dialogTitle!: string;
  @Prop()
  private dialogText!: string;
  @Prop()
  private disabled!: boolean;
  @Prop()
  private hint!: VueI18n.TranslateResult;

  private clickBtnCancel() {
    this.dialog = false;
  }
  @Emit('dialog-ok')
  private clickBtnOK() {
    this.dialog = false;
  }
}
